import { render, staticRenderFns } from "./k-objects-base.vue?vue&type=template&id=54fdcd2c&lang=pug&"
import script from "./k-objects-base.vue?vue&type=script&lang=js&"
export * from "./k-objects-base.vue?vue&type=script&lang=js&"
import style0 from "./k-objects-base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fdcd2c')) {
      api.createRecord('54fdcd2c', component.options)
    } else {
      api.reload('54fdcd2c', component.options)
    }
    module.hot.accept("./k-objects-base.vue?vue&type=template&id=54fdcd2c&lang=pug&", function () {
      api.rerender('54fdcd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-objects-base.vue"
export default component.exports